export default "__VITE_ASSET__aRrb2Aou__"